/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppProjetsSlugRouteImport } from './routes/app/projets/$slug'
import { Route as AppProjetsSlugPoseurIndexRouteImport } from './routes/app/projets/$slug/poseur/index'
import { Route as AppProjetsSlugPhotosIndexRouteImport } from './routes/app/projets/$slug/photos/index'
import { Route as AppProjetsSlugLivraisonEtPoseIndexRouteImport } from './routes/app/projets/$slug/livraison-et-pose/index'
import { Route as AppProjetsSlugLettresIndexRouteImport } from './routes/app/projets/$slug/lettres/index'
import { Route as AppProjetsSlugFacturationIndexRouteImport } from './routes/app/projets/$slug/facturation/index'
import { Route as AppProjetsSlugDocumentsIndexRouteImport } from './routes/app/projets/$slug/documents/index'
import { Route as AppProjetsSlugClientIndexRouteImport } from './routes/app/projets/$slug/client/index'
import { Route as AppProjetsSlugBudgetIndexRouteImport } from './routes/app/projets/$slug/budget/index'

const TestIndexLazyRouteImport = createFileRoute('/test/')()
const AppUtilisateursIndexLazyRouteImport =
  createFileRoute('/app/utilisateurs/')()
const AppProjetsIndexLazyRouteImport = createFileRoute('/app/projets/')()
const AppProfilIndexLazyRouteImport = createFileRoute('/app/profil/')()
const AppFacturesIndexLazyRouteImport = createFileRoute('/app/factures/')()
const AppConfigurationIndexLazyRouteImport = createFileRoute(
  '/app/configuration/',
)()
const AppClientsIndexLazyRouteImport = createFileRoute('/app/clients/')()
const AppProjetsSlugInformationsIndexLazyRouteImport = createFileRoute(
  '/app/projets/$slug/informations/',
)()
const AppProjetsSlugFicheFournisseurIndexLazyRouteImport = createFileRoute(
  '/app/projets/$slug/fiche-fournisseur/',
)()
const AppProjetsSlugAvoirsIndexLazyRouteImport = createFileRoute(
  '/app/projets/$slug/avoirs/',
)()

const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestIndexLazyRoute = TestIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TestRoute,
} as any).lazy(() => import('./routes/test/index.lazy').then((d) => d.Route))
const AppUtilisateursIndexLazyRoute =
  AppUtilisateursIndexLazyRouteImport.update({
    id: '/utilisateurs/',
    path: '/utilisateurs/',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/app/utilisateurs/index.lazy').then((d) => d.Route),
  )
const AppProjetsIndexLazyRoute = AppProjetsIndexLazyRouteImport.update({
  id: '/projets/',
  path: '/projets/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app/projets/index.lazy').then((d) => d.Route),
)
const AppProfilIndexLazyRoute = AppProfilIndexLazyRouteImport.update({
  id: '/profil/',
  path: '/profil/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app/profil/index.lazy').then((d) => d.Route),
)
const AppFacturesIndexLazyRoute = AppFacturesIndexLazyRouteImport.update({
  id: '/factures/',
  path: '/factures/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app/factures/index.lazy').then((d) => d.Route),
)
const AppConfigurationIndexLazyRoute =
  AppConfigurationIndexLazyRouteImport.update({
    id: '/configuration/',
    path: '/configuration/',
    getParentRoute: () => AppRoute,
  } as any).lazy(() =>
    import('./routes/app/configuration/index.lazy').then((d) => d.Route),
  )
const AppClientsIndexLazyRoute = AppClientsIndexLazyRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import('./routes/app/clients/index.lazy').then((d) => d.Route),
)
const AppProjetsSlugRoute = AppProjetsSlugRouteImport.update({
  id: '/projets/$slug',
  path: '/projets/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppProjetsSlugInformationsIndexLazyRoute =
  AppProjetsSlugInformationsIndexLazyRouteImport.update({
    id: '/informations/',
    path: '/informations/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/projets/$slug/informations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppProjetsSlugFicheFournisseurIndexLazyRoute =
  AppProjetsSlugFicheFournisseurIndexLazyRouteImport.update({
    id: '/fiche-fournisseur/',
    path: '/fiche-fournisseur/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/projets/$slug/fiche-fournisseur/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppProjetsSlugAvoirsIndexLazyRoute =
  AppProjetsSlugAvoirsIndexLazyRouteImport.update({
    id: '/avoirs/',
    path: '/avoirs/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any).lazy(() =>
    import('./routes/app/projets/$slug/avoirs/index.lazy').then((d) => d.Route),
  )
const AppProjetsSlugPoseurIndexRoute =
  AppProjetsSlugPoseurIndexRouteImport.update({
    id: '/poseur/',
    path: '/poseur/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)
const AppProjetsSlugPhotosIndexRoute =
  AppProjetsSlugPhotosIndexRouteImport.update({
    id: '/photos/',
    path: '/photos/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)
const AppProjetsSlugLivraisonEtPoseIndexRoute =
  AppProjetsSlugLivraisonEtPoseIndexRouteImport.update({
    id: '/livraison-et-pose/',
    path: '/livraison-et-pose/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)
const AppProjetsSlugLettresIndexRoute =
  AppProjetsSlugLettresIndexRouteImport.update({
    id: '/lettres/',
    path: '/lettres/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)
const AppProjetsSlugFacturationIndexRoute =
  AppProjetsSlugFacturationIndexRouteImport.update({
    id: '/facturation/',
    path: '/facturation/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)
const AppProjetsSlugDocumentsIndexRoute =
  AppProjetsSlugDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)
const AppProjetsSlugClientIndexRoute =
  AppProjetsSlugClientIndexRouteImport.update({
    id: '/client/',
    path: '/client/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)
const AppProjetsSlugBudgetIndexRoute =
  AppProjetsSlugBudgetIndexRouteImport.update({
    id: '/budget/',
    path: '/budget/',
    getParentRoute: () => AppProjetsSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/test': typeof TestRouteWithChildren
  '/test/': typeof TestIndexLazyRoute
  '/app/projets/$slug': typeof AppProjetsSlugRouteWithChildren
  '/app/clients': typeof AppClientsIndexLazyRoute
  '/app/configuration': typeof AppConfigurationIndexLazyRoute
  '/app/factures': typeof AppFacturesIndexLazyRoute
  '/app/profil': typeof AppProfilIndexLazyRoute
  '/app/projets': typeof AppProjetsIndexLazyRoute
  '/app/utilisateurs': typeof AppUtilisateursIndexLazyRoute
  '/app/projets/$slug/budget': typeof AppProjetsSlugBudgetIndexRoute
  '/app/projets/$slug/client': typeof AppProjetsSlugClientIndexRoute
  '/app/projets/$slug/documents': typeof AppProjetsSlugDocumentsIndexRoute
  '/app/projets/$slug/facturation': typeof AppProjetsSlugFacturationIndexRoute
  '/app/projets/$slug/lettres': typeof AppProjetsSlugLettresIndexRoute
  '/app/projets/$slug/livraison-et-pose': typeof AppProjetsSlugLivraisonEtPoseIndexRoute
  '/app/projets/$slug/photos': typeof AppProjetsSlugPhotosIndexRoute
  '/app/projets/$slug/poseur': typeof AppProjetsSlugPoseurIndexRoute
  '/app/projets/$slug/avoirs': typeof AppProjetsSlugAvoirsIndexLazyRoute
  '/app/projets/$slug/fiche-fournisseur': typeof AppProjetsSlugFicheFournisseurIndexLazyRoute
  '/app/projets/$slug/informations': typeof AppProjetsSlugInformationsIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/test': typeof TestIndexLazyRoute
  '/app/projets/$slug': typeof AppProjetsSlugRouteWithChildren
  '/app/clients': typeof AppClientsIndexLazyRoute
  '/app/configuration': typeof AppConfigurationIndexLazyRoute
  '/app/factures': typeof AppFacturesIndexLazyRoute
  '/app/profil': typeof AppProfilIndexLazyRoute
  '/app/projets': typeof AppProjetsIndexLazyRoute
  '/app/utilisateurs': typeof AppUtilisateursIndexLazyRoute
  '/app/projets/$slug/budget': typeof AppProjetsSlugBudgetIndexRoute
  '/app/projets/$slug/client': typeof AppProjetsSlugClientIndexRoute
  '/app/projets/$slug/documents': typeof AppProjetsSlugDocumentsIndexRoute
  '/app/projets/$slug/facturation': typeof AppProjetsSlugFacturationIndexRoute
  '/app/projets/$slug/lettres': typeof AppProjetsSlugLettresIndexRoute
  '/app/projets/$slug/livraison-et-pose': typeof AppProjetsSlugLivraisonEtPoseIndexRoute
  '/app/projets/$slug/photos': typeof AppProjetsSlugPhotosIndexRoute
  '/app/projets/$slug/poseur': typeof AppProjetsSlugPoseurIndexRoute
  '/app/projets/$slug/avoirs': typeof AppProjetsSlugAvoirsIndexLazyRoute
  '/app/projets/$slug/fiche-fournisseur': typeof AppProjetsSlugFicheFournisseurIndexLazyRoute
  '/app/projets/$slug/informations': typeof AppProjetsSlugInformationsIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/test': typeof TestRouteWithChildren
  '/test/': typeof TestIndexLazyRoute
  '/app/projets/$slug': typeof AppProjetsSlugRouteWithChildren
  '/app/clients/': typeof AppClientsIndexLazyRoute
  '/app/configuration/': typeof AppConfigurationIndexLazyRoute
  '/app/factures/': typeof AppFacturesIndexLazyRoute
  '/app/profil/': typeof AppProfilIndexLazyRoute
  '/app/projets/': typeof AppProjetsIndexLazyRoute
  '/app/utilisateurs/': typeof AppUtilisateursIndexLazyRoute
  '/app/projets/$slug/budget/': typeof AppProjetsSlugBudgetIndexRoute
  '/app/projets/$slug/client/': typeof AppProjetsSlugClientIndexRoute
  '/app/projets/$slug/documents/': typeof AppProjetsSlugDocumentsIndexRoute
  '/app/projets/$slug/facturation/': typeof AppProjetsSlugFacturationIndexRoute
  '/app/projets/$slug/lettres/': typeof AppProjetsSlugLettresIndexRoute
  '/app/projets/$slug/livraison-et-pose/': typeof AppProjetsSlugLivraisonEtPoseIndexRoute
  '/app/projets/$slug/photos/': typeof AppProjetsSlugPhotosIndexRoute
  '/app/projets/$slug/poseur/': typeof AppProjetsSlugPoseurIndexRoute
  '/app/projets/$slug/avoirs/': typeof AppProjetsSlugAvoirsIndexLazyRoute
  '/app/projets/$slug/fiche-fournisseur/': typeof AppProjetsSlugFicheFournisseurIndexLazyRoute
  '/app/projets/$slug/informations/': typeof AppProjetsSlugInformationsIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/login'
    | '/test'
    | '/test/'
    | '/app/projets/$slug'
    | '/app/clients'
    | '/app/configuration'
    | '/app/factures'
    | '/app/profil'
    | '/app/projets'
    | '/app/utilisateurs'
    | '/app/projets/$slug/budget'
    | '/app/projets/$slug/client'
    | '/app/projets/$slug/documents'
    | '/app/projets/$slug/facturation'
    | '/app/projets/$slug/lettres'
    | '/app/projets/$slug/livraison-et-pose'
    | '/app/projets/$slug/photos'
    | '/app/projets/$slug/poseur'
    | '/app/projets/$slug/avoirs'
    | '/app/projets/$slug/fiche-fournisseur'
    | '/app/projets/$slug/informations'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/login'
    | '/test'
    | '/app/projets/$slug'
    | '/app/clients'
    | '/app/configuration'
    | '/app/factures'
    | '/app/profil'
    | '/app/projets'
    | '/app/utilisateurs'
    | '/app/projets/$slug/budget'
    | '/app/projets/$slug/client'
    | '/app/projets/$slug/documents'
    | '/app/projets/$slug/facturation'
    | '/app/projets/$slug/lettres'
    | '/app/projets/$slug/livraison-et-pose'
    | '/app/projets/$slug/photos'
    | '/app/projets/$slug/poseur'
    | '/app/projets/$slug/avoirs'
    | '/app/projets/$slug/fiche-fournisseur'
    | '/app/projets/$slug/informations'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/login'
    | '/test'
    | '/test/'
    | '/app/projets/$slug'
    | '/app/clients/'
    | '/app/configuration/'
    | '/app/factures/'
    | '/app/profil/'
    | '/app/projets/'
    | '/app/utilisateurs/'
    | '/app/projets/$slug/budget/'
    | '/app/projets/$slug/client/'
    | '/app/projets/$slug/documents/'
    | '/app/projets/$slug/facturation/'
    | '/app/projets/$slug/lettres/'
    | '/app/projets/$slug/livraison-et-pose/'
    | '/app/projets/$slug/photos/'
    | '/app/projets/$slug/poseur/'
    | '/app/projets/$slug/avoirs/'
    | '/app/projets/$slug/fiche-fournisseur/'
    | '/app/projets/$slug/informations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  TestRoute: typeof TestRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/': {
      id: '/test/'
      path: '/'
      fullPath: '/test/'
      preLoaderRoute: typeof TestIndexLazyRouteImport
      parentRoute: typeof TestRoute
    }
    '/app/utilisateurs/': {
      id: '/app/utilisateurs/'
      path: '/utilisateurs'
      fullPath: '/app/utilisateurs'
      preLoaderRoute: typeof AppUtilisateursIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/projets/': {
      id: '/app/projets/'
      path: '/projets'
      fullPath: '/app/projets'
      preLoaderRoute: typeof AppProjetsIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/profil/': {
      id: '/app/profil/'
      path: '/profil'
      fullPath: '/app/profil'
      preLoaderRoute: typeof AppProfilIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/factures/': {
      id: '/app/factures/'
      path: '/factures'
      fullPath: '/app/factures'
      preLoaderRoute: typeof AppFacturesIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/configuration/': {
      id: '/app/configuration/'
      path: '/configuration'
      fullPath: '/app/configuration'
      preLoaderRoute: typeof AppConfigurationIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clients/': {
      id: '/app/clients/'
      path: '/clients'
      fullPath: '/app/clients'
      preLoaderRoute: typeof AppClientsIndexLazyRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/projets/$slug': {
      id: '/app/projets/$slug'
      path: '/projets/$slug'
      fullPath: '/app/projets/$slug'
      preLoaderRoute: typeof AppProjetsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/projets/$slug/informations/': {
      id: '/app/projets/$slug/informations/'
      path: '/informations'
      fullPath: '/app/projets/$slug/informations'
      preLoaderRoute: typeof AppProjetsSlugInformationsIndexLazyRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/fiche-fournisseur/': {
      id: '/app/projets/$slug/fiche-fournisseur/'
      path: '/fiche-fournisseur'
      fullPath: '/app/projets/$slug/fiche-fournisseur'
      preLoaderRoute: typeof AppProjetsSlugFicheFournisseurIndexLazyRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/avoirs/': {
      id: '/app/projets/$slug/avoirs/'
      path: '/avoirs'
      fullPath: '/app/projets/$slug/avoirs'
      preLoaderRoute: typeof AppProjetsSlugAvoirsIndexLazyRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/poseur/': {
      id: '/app/projets/$slug/poseur/'
      path: '/poseur'
      fullPath: '/app/projets/$slug/poseur'
      preLoaderRoute: typeof AppProjetsSlugPoseurIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/photos/': {
      id: '/app/projets/$slug/photos/'
      path: '/photos'
      fullPath: '/app/projets/$slug/photos'
      preLoaderRoute: typeof AppProjetsSlugPhotosIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/livraison-et-pose/': {
      id: '/app/projets/$slug/livraison-et-pose/'
      path: '/livraison-et-pose'
      fullPath: '/app/projets/$slug/livraison-et-pose'
      preLoaderRoute: typeof AppProjetsSlugLivraisonEtPoseIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/lettres/': {
      id: '/app/projets/$slug/lettres/'
      path: '/lettres'
      fullPath: '/app/projets/$slug/lettres'
      preLoaderRoute: typeof AppProjetsSlugLettresIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/facturation/': {
      id: '/app/projets/$slug/facturation/'
      path: '/facturation'
      fullPath: '/app/projets/$slug/facturation'
      preLoaderRoute: typeof AppProjetsSlugFacturationIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/documents/': {
      id: '/app/projets/$slug/documents/'
      path: '/documents'
      fullPath: '/app/projets/$slug/documents'
      preLoaderRoute: typeof AppProjetsSlugDocumentsIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/client/': {
      id: '/app/projets/$slug/client/'
      path: '/client'
      fullPath: '/app/projets/$slug/client'
      preLoaderRoute: typeof AppProjetsSlugClientIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
    '/app/projets/$slug/budget/': {
      id: '/app/projets/$slug/budget/'
      path: '/budget'
      fullPath: '/app/projets/$slug/budget'
      preLoaderRoute: typeof AppProjetsSlugBudgetIndexRouteImport
      parentRoute: typeof AppProjetsSlugRoute
    }
  }
}

interface AppProjetsSlugRouteChildren {
  AppProjetsSlugBudgetIndexRoute: typeof AppProjetsSlugBudgetIndexRoute
  AppProjetsSlugClientIndexRoute: typeof AppProjetsSlugClientIndexRoute
  AppProjetsSlugDocumentsIndexRoute: typeof AppProjetsSlugDocumentsIndexRoute
  AppProjetsSlugFacturationIndexRoute: typeof AppProjetsSlugFacturationIndexRoute
  AppProjetsSlugLettresIndexRoute: typeof AppProjetsSlugLettresIndexRoute
  AppProjetsSlugLivraisonEtPoseIndexRoute: typeof AppProjetsSlugLivraisonEtPoseIndexRoute
  AppProjetsSlugPhotosIndexRoute: typeof AppProjetsSlugPhotosIndexRoute
  AppProjetsSlugPoseurIndexRoute: typeof AppProjetsSlugPoseurIndexRoute
  AppProjetsSlugAvoirsIndexLazyRoute: typeof AppProjetsSlugAvoirsIndexLazyRoute
  AppProjetsSlugFicheFournisseurIndexLazyRoute: typeof AppProjetsSlugFicheFournisseurIndexLazyRoute
  AppProjetsSlugInformationsIndexLazyRoute: typeof AppProjetsSlugInformationsIndexLazyRoute
}

const AppProjetsSlugRouteChildren: AppProjetsSlugRouteChildren = {
  AppProjetsSlugBudgetIndexRoute: AppProjetsSlugBudgetIndexRoute,
  AppProjetsSlugClientIndexRoute: AppProjetsSlugClientIndexRoute,
  AppProjetsSlugDocumentsIndexRoute: AppProjetsSlugDocumentsIndexRoute,
  AppProjetsSlugFacturationIndexRoute: AppProjetsSlugFacturationIndexRoute,
  AppProjetsSlugLettresIndexRoute: AppProjetsSlugLettresIndexRoute,
  AppProjetsSlugLivraisonEtPoseIndexRoute:
    AppProjetsSlugLivraisonEtPoseIndexRoute,
  AppProjetsSlugPhotosIndexRoute: AppProjetsSlugPhotosIndexRoute,
  AppProjetsSlugPoseurIndexRoute: AppProjetsSlugPoseurIndexRoute,
  AppProjetsSlugAvoirsIndexLazyRoute: AppProjetsSlugAvoirsIndexLazyRoute,
  AppProjetsSlugFicheFournisseurIndexLazyRoute:
    AppProjetsSlugFicheFournisseurIndexLazyRoute,
  AppProjetsSlugInformationsIndexLazyRoute:
    AppProjetsSlugInformationsIndexLazyRoute,
}

const AppProjetsSlugRouteWithChildren = AppProjetsSlugRoute._addFileChildren(
  AppProjetsSlugRouteChildren,
)

interface AppRouteChildren {
  AppProjetsSlugRoute: typeof AppProjetsSlugRouteWithChildren
  AppClientsIndexLazyRoute: typeof AppClientsIndexLazyRoute
  AppConfigurationIndexLazyRoute: typeof AppConfigurationIndexLazyRoute
  AppFacturesIndexLazyRoute: typeof AppFacturesIndexLazyRoute
  AppProfilIndexLazyRoute: typeof AppProfilIndexLazyRoute
  AppProjetsIndexLazyRoute: typeof AppProjetsIndexLazyRoute
  AppUtilisateursIndexLazyRoute: typeof AppUtilisateursIndexLazyRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppProjetsSlugRoute: AppProjetsSlugRouteWithChildren,
  AppClientsIndexLazyRoute: AppClientsIndexLazyRoute,
  AppConfigurationIndexLazyRoute: AppConfigurationIndexLazyRoute,
  AppFacturesIndexLazyRoute: AppFacturesIndexLazyRoute,
  AppProfilIndexLazyRoute: AppProfilIndexLazyRoute,
  AppProjetsIndexLazyRoute: AppProjetsIndexLazyRoute,
  AppUtilisateursIndexLazyRoute: AppUtilisateursIndexLazyRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface TestRouteChildren {
  TestIndexLazyRoute: typeof TestIndexLazyRoute
}

const TestRouteChildren: TestRouteChildren = {
  TestIndexLazyRoute: TestIndexLazyRoute,
}

const TestRouteWithChildren = TestRoute._addFileChildren(TestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  TestRoute: TestRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
